import { RadioSelectedIcon, RadioUnselectedIcon } from '@ardoq/icons';
import { RadioFocusBox } from './atoms';
import styled from 'styled-components';

type FocusableRadioIconProps = {
  isChecked?: boolean;
  isFocused?: boolean;
};

export const FocusableRadioIcon = ({
  isChecked,
  isFocused,
}: FocusableRadioIconProps) => {
  const IconComponent = isChecked ? RadioSelectedIcon : RadioUnselectedIcon;
  return (
    <Wrapper className="radio-icon-wrapper">
      <IconComponent />
      {isFocused && <RadioFocusBox />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 1px; /* space for the focus box */
  position: relative; /* focus box has absolute positioning */
  line-height: 0; /* removes space below the icon */
`;
